<template>
  <v-dialog v-model="modal" fullscreen @keydown.esc="modal = false" persistent>
    <v-toolbar flat dark color="primary">
      <v-toolbar-title class="h2">
        {{ heading }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card>
      <!-- 通知設定本体 -->
      <!-- 子の側からheadingを変えれるようにする -->
      <attributionSetting :initialMode="true" @updateHeading="newHeading => heading = newHeading" />

    </v-card>
  </v-dialog>
</template>
<script>
import attributionSetting from './attributionSetting.vue';
export default {
  data() {
    return {
      modal: true,
      heading: this.$store.state.auth.data.attributionDef?.heading || 'アンケートにお答えください'
    };
  },
  computed: {
  },
  components: {
    attributionSetting,
  },
}
</script>